import CloseIcon from '@mui/icons-material/Close'
import { IconButton, useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { useAuth } from 'react-oidc-context'
import { theme } from '../../theme'

export const DemoHiDialog = ({ open, handleClose }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const auth = useAuth()

    const handleClickRegistration = () => {
        auth.signoutRedirect()
    }
    return (
        <>
            <Dialog
                open={open}
                PaperProps={{
                    style: {
                        width: '490px',
                    },
                }}>
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        marginBottom: '0',
                        padding: '32px 32px 0',
                        border: 'none',
                    }}>
                    <img
                        src="/logo.svg"
                        style={{
                            width: '200px',
                            height: '100%',
                        }}
                    />
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            border: '1px solid #E9EAED',
                        }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h4" mb={2}>
                        Добро пожаловать в ARHIASSISTANT!
                    </Typography>
                    <Typography variant="body2" mb={2}>
                        Начните общение прямо сейчас — бесплатно и без регистрации.
                    </Typography>
                    <Typography variant="body2">
                        Нажмите «Попробовать бесплатно» и получите доступ к ассистенту и другим
                        моделям:
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#181B25', fontWeight: 500 }} mb={2}>
                        5 сообщений и 3 дня демо-доступа.
                    </Typography>
                    <Box sx={{ background: '#F9FAFB', borderRadius: '16px', p: '16px', mt: 1 }}>
                        <Typography
                            variant="caption2"
                            component="p"
                            sx={{ color: '#5A5F72', fontWeight: '500' }}
                            mb={1}>
                            Важно!
                        </Typography>
                        <Typography variant="caption2" sx={{ color: '#5A5F72' }} component="p">
                            Если вы закроете вкладку, история диалога исчезнет.
                        </Typography>
                        <Typography
                            variant="caption2"
                            sx={{ color: '#5A5F72' }}
                            mt={3}
                            component="p">
                            Хотите сохранить переписку и получить полный доступ ко всем функциям?
                            Зарегистрируйтесь — это быстро!
                        </Typography>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ flexDirection: isMobile ? 'column' : 'row' }}>
                    <Button
                        fullWidth={isMobile}
                        onClick={handleClickRegistration}
                        variant="outlined"
                        sx={{ background: '#F9FAFB', mb: isMobile ? 2 : 0 }}>
                        Зарегистрироваться
                    </Button>
                    <Button onClick={handleClose} variant="contained" fullWidth={isMobile}>
                        Попробовать бесплатно
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
